import { render, staticRenderFns } from "./shopGoodsList.vue?vue&type=template&id=9efa260a&scoped=true&"
import script from "./shopGoodsList.vue?vue&type=script&lang=js&"
export * from "./shopGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./shopGoodsList.vue?vue&type=style&index=0&id=9efa260a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efa260a",
  null
  
)

export default component.exports